(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  }

  function initReviewSection(root) {
    if (root.hasAttribute('data-reviews-bound')) return;
    root.setAttribute('data-reviews-bound', '');
    root.setAttribute('data-enhanced', '');

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-review-card]'));
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-review-filter]'));
    var more = root.querySelector('[data-review-more]');
    var initialCount = parseInt(root.getAttribute('data-initial-count'), 10) || 6;
    var visibleLimit = initialCount;
    var currentFilter = 'all';

    function eligibleCards() {
      if (currentFilter === 'photo') {
        return cards.filter(function (card) { return card.getAttribute('data-review-has-photo') === 'true'; });
      }
      return cards;
    }

    function renderCards() {
      var eligible = eligibleCards();
      cards.forEach(function (card) { card.hidden = true; });
      eligible.slice(0, visibleLimit).forEach(function (card) { card.hidden = false; });
      if (more) {
        var finished = visibleLimit >= eligible.length;
        more.closest('.roadnest-reviews__more-wrap').hidden = finished;
        more.setAttribute('aria-expanded', finished ? 'true' : 'false');
      }
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        currentFilter = button.getAttribute('data-review-filter') || 'all';
        visibleLimit = initialCount;
        filters.forEach(function (item) { item.setAttribute('aria-pressed', item === button ? 'true' : 'false'); });
        renderCards();
      });
    });

    if (more) {
      // The control says "Voir tous les avis", so it reveals all of them —
      // not another batch. Focus moves to the first newly shown card.
      more.addEventListener('click', function () {
        var firstNewIndex = visibleLimit;
        visibleLimit = eligibleCards().length;
        renderCards();
        var newlyVisible = eligibleCards()[firstNewIndex];
        if (newlyVisible) {
          newlyVisible.setAttribute('tabindex', '-1');
          newlyVisible.focus({ preventScroll: true });
        }
      });
    }

    root.querySelectorAll('[data-review-read-more]').forEach(function (button) {
      var body = button.previousElementSibling;
      if (!body) return;
      if (body.scrollHeight > body.clientHeight + 2) button.hidden = false;
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        body.classList.toggle('is-expanded', !expanded);
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        button.textContent = expanded ? 'Lire la suite' : 'Réduire';
      });
    });

    root.querySelectorAll('.roadnest-reviews__media img').forEach(function (image) {
      function hideMissingMedia() {
        var media = image.closest('.roadnest-reviews__media');
        var card = image.closest('[data-review-card]');
        if (media) media.hidden = true;
        if (card) card.setAttribute('data-review-has-photo', 'false');
        renderCards();
      }
      image.addEventListener('error', hideMissingMedia);
      if (image.complete && image.naturalWidth === 0) hideMissingMedia();
    });

    renderCards();
  }

  function initLightboxes() {
    var returnFocus = null;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-review-lightbox]');
      var close = event.target.closest('[data-review-dialog-close]');
      if (trigger) {
        var key = trigger.getAttribute('data-review-dialog-target');
        var dialog = document.querySelector('[data-review-dialog="' + key + '"]');
        if (!dialog) return;
        var image = dialog.querySelector('img');
        var caption = dialog.querySelector('figcaption');
        image.src = trigger.getAttribute('data-review-full-src') || '';
        image.alt = trigger.getAttribute('data-review-alt') || '';
        caption.textContent = trigger.getAttribute('data-review-caption') || '';
        returnFocus = trigger;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        dialog.querySelector('[data-review-dialog-close]').focus();
      }
      if (close) close.closest('dialog').close();
    });

    document.querySelectorAll('[data-review-dialog]').forEach(function (dialog) {
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', function () {
        if (returnFocus) returnFocus.focus();
        returnFocus = null;
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-roadnest-reviews-full]').forEach(initReviewSection);
    initLightboxes();
  });
})();
